module.exports = __webpack_public_path__ + "static/img/concat.4e5ff5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/concat.png
// module id = Q4nT
// module chunks = 1